import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../api/client';
import { Globe, ArrowRight } from 'lucide-react';

interface Agent {
  id: string;
  name: string;
  description?: string;
}

export default function AssetRuntimeOverview() {
  const [agents, setAgents] = useState<Agent[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    apiClient
      .get('/agents')
      .then((res) => setAgents(res.data))
      .catch((e) => console.error('Failed to load agents:', e))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="container">
      <h1>Asset Runtime</h1>
      <p className="text-muted mb-4">将 Agent 的能力（人设 / 技能 / 知识 / MCP / 工作流）部署为独立在线服务</p>

      {agents.length === 0 ? (
        <div className="empty">
          <h3>暂无 Agent</h3>
          <button className="primary mt-2" onClick={() => navigate('/agents/create')}>
            新建 Agent
          </button>
        </div>
      ) : (
        <div className="list">
          {agents.map((agent) => (
            <div key={agent.id} className="list-item">
              <div className="list-item-content">
                <div className="flex items-center gap-2">
                  <Globe size={18} />
                  <h3 style={{ margin: 0 }}>{agent.name}</h3>
                </div>
                <p className="text-muted text-sm" style={{ margin: '4px 0 0' }}>
                  {agent.description || '暂无描述'}
                </p>
              </div>
              <button
                className="secondary"
                style={{ padding: '6px 12px' }}
                onClick={() => navigate(`/agents/${agent.id}/config-center`)}
              >
                管理运行时 <ArrowRight size={14} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
